(function () {
  const checkoutBtns = document.querySelectorAll('button[name="checkout"]');

  if (checkoutBtns) {
    checkoutBtns.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        await removeOutOfStockProducts();
        window.location.href = "/checkout";
      })
    });
  }

  async function removeOutOfStockProducts() {
    try {
      // Get the products in the cart
      const response = await fetch('/cart.js');
      const cart = await response.json();

      if (!cart.items) {
        return;
      }
      
      const basket = { updates: {} };
      const persProducts = cart.items.filter(item => item.sku.includes('-PERS'));
      const persAddons = cart.items.filter(item => item.sku === 'PERSONALISATION');

      // Validate the personalised products have stock available
      if (persProducts) {
        for (const product of persProducts) {
          const checkProduct = await fetch(`/products/${product.handle}.js`);
          const productData = await checkProduct.json();
  
          if (!productData.available && product.properties._cartId) {
            // If product is not available get the _cartID property
            const cartItemId = product.properties._cartId;
            if (!cartItemId) {
              continue;
            }
            persAddons.forEach(addon => {
              if (addon.properties._cartId === cartItemId) {
                // Remove the product and any addons from the basket
                basket.updates[product.key] = "0";
                basket.updates[addon.key] = "0";
              }
            });
          }
        }
      }

      // Validate addons have both cartId and forProduct attributes
      if (persAddons) {
        for (const addon of persAddons) {
          if (addon.properties._cartId === undefined || addon.properties.forProduct === undefined) {
            basket.updates[addon.key] = "0";
          }
        } 
      }

      // Post basket updates
      if (basket.updates !== undefined) {
        const updateBasket = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: basket.updates })
        })
        
        if (!updateBasket.ok) {
          console.error('Error removing out of stock products', error);
        }
      }
    } catch (error) {
      console.error('Error removing out of stock products', error);
    }
  }
}())